import { API_BASE } from './api-base';
import { apiFetch } from './api-client';

/**
 * File a piece of product feedback from the app itself — a feature wish, a vote — WITHOUT a chat: it goes
 * to the same feedback channel the agent's own reports reach (the harness's FeedbackDelivery pipeline),
 * so a wish counts where every wish is counted. Best-effort: a failure is the caller's to decide on.
 */
export async function sendFeedback(input: { feedback: string; topic: string }): Promise<boolean> {
  const res = await apiFetch(`${API_BASE}/api/feedback`, { method: 'POST', credentials: 'include', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(input) });
  return res.ok;
}
